import * as React from "react";
import { forwardRef } from "react";
const SvgFilterFunnel = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M30 12L22 20V28L18 30V20L10 12V9H30V12Z", stroke: "currentColor", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgFilterFunnel);
export default ForwardRef;
